export const css = /* css */ `
:host,
:host *,
*::before,
*::after {
  box-sizing: border-box;
}
a {
  color: inherit;
}
:not(.focus-visible),
:host(:not(.focus-visible)) {
  outline: none;
}
[hidden] {
  display: none !important;
}
:host {
  user-select: none;
  -webkit-user-select: none;
  display: inline-block;
  font-size: 0;
  background: transparent;
  position: relative;
}
:host div {
  font-size: 0;
  position: relative;
}
:host div:before {
  position: absolute;
  top: 0;
  left: 0;
  width: calc(var(--erem) * 1.5);
  height: calc(var(--erem) * 1.5);
  border: 2px solid var(--slicesui-toggle-background, #ccc);
  border-radius: 50%;
  background: var(--slicesui-toggle-knob-background, #fff);
  content: '';
  transition: 0.2s transform ease, 0.2s border-color ease;
  pointer-events: none;
  z-index: 1;
}
:host([checked]) div:before {
  border-color: var(--slicesui-toggle-background--checked, #000);
  background: var(--slicesui-toggle-knob-background--checked, #fff);
  transform: translateX(100%);
}
:host input {
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  margin: 0;
  line-height: 1.2;
  width: calc(var(--erem) * 3);
  height: calc(var(--erem) * 1.5);
  border: 0;
  background: var(--slicesui-toggle-background, #ccc);
  color: var(--slicesui-toggle-color, #000);
  border-radius: 32px;
  border-width: 2px;
  border-style: solid;
  border-color: var(--slicesui-toggle-background, #ccc);
  transition: 0.2s background ease, 0.2s border-color ease;
}
:host input:not([disabled]) {
  cursor: pointer;
}
:host input:disabled {
  cursor: default;
  opacity: 0.5;
}
:host input:checked {
  background: var(--slicesui-toggle-background--checked, #000);
  border-color: var(--slicesui-toggle-background--checked, #000);
}
:host([disabled]):after {
  opacity: 0.5;
}
`;